<template>
    <div class="files-upload">
      <input 
        type="file" 
        id="uFile" 
        name="uFile" 
        style="display: none;" 
        @change="handleInputUpload($event)" 
      />
      <div class="upload-button" v-if="fileList.length < routeQuery.maxCount" @click="handleSelectFile">
        <van-icon name="add-o" class="add-o" size="18px" />上传附件
      </div>
      <div class="file-list" v-if="fileList.length">
        <div class="file-item" v-for="(item,index) in fileList" :key="item.newFileName">
          <div style="display: flex;align-items: center;">
            <van-image
              v-if="handleFileIconOption(item.fileName).iconName === 'image-icon'"
              height="40"
              :src="item.fileUrl"
              style="margin-right: 20px;flex-shrink: 0;"
            >
              <template slot="loading">
                <van-image
                  :width="handleFileIconOption(item.fileName).width"
                  :height="handleFileIconOption(item.fileName).height"
                  :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.fileName).iconName}.png`)"
                />
              </template>
              <template slot="error">
                <van-image
                  :width="handleFileIconOption(item.fileName).width"
                  :height="handleFileIconOption(item.fileName).height"
                  :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.fileName).iconName}.png`)"
                />
              </template>
            </van-image>
            <van-image
              v-else
              :width="handleFileIconOption(item.fileName).width"
              :height="handleFileIconOption(item.fileName).height"
              :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.fileName).iconName}.png`)"
              style="margin-right: 20px;flex-shrink: 0;"
            />
            <div style="flex: 1;overflow: hidden;">
              <div style="display: flex;align-items: center;overflow: hidden;">
                <div style="flex: 1;overflow: hidden;display: flex;align-items: center;">
                  <div class="file-name">{{ item.fileName.slice(0,item.fileName.lastIndexOf(".")) }}</div>
                  <div class="file-name-suffix">{{ item.fileName.slice(item.fileName.lastIndexOf(".")) }}</div>
                </div>
                <div class="file-delete" @click="handleDelete(item,index)">删除</div>
              </div>
              <div class="file-size">{{ filesizeFormat(item.fileSize) }}</div>
            </div>
          </div>
          <div class="file-upload-time">{{ item.lastModifiedDate ? item.lastModifiedDate.split(" ")[0] : "" }}</div>
        </div>
      </div>
      <div class="pages-footer">
          <div class="button --plain" @click="handleCancel">取消</div>
          <div class="button" @click="handleSubmit">确认</div>
      </div>
    </div>
  </template>
  
  <script>
  import { Uploader , Icon , Image as VanImage } from 'vant';
  import { upload } from "@/api/dispatchIncidentFollow/filesUpload/index.js";
  import { parseTime } from "@/utils/ruoyi.js";
  import { getToken } from "@/utils/auth.js";
  export default {
    components:{
      [Uploader.name]:Uploader,
      [Icon.name]:Icon,
      [VanImage.name]:VanImage,
    },
    data(){
      return {
        fileList:[],
        fileSuffixList:[
          { iconName: "word-icon" , suffixList:["doc","docx"] , width: "36" , height: "40" },
          { iconName: "excel-icon" , suffixList:["xls","xlsx"] , width: "36" , height: "40" },  
          { iconName: "ppt-icon" , suffixList:["ppt","pptx"] , width: "36" , height: "40"},
          { iconName: "pdf-icon" , suffixList:["pdf"] , width: "39" , height: "40" },
          { iconName: "image-icon" , suffixList:["bmp","gif","ico","jpg","png","webp","heic","raw"] , width: "36" , height: "36" },
          { iconName: "video-icon" , suffixList:["mp4","flv","m3u8","rtmp","hls","rtsp","mov"] , width: "36" , height: "36" },
          { iconName: "audio-icon" , suffixList:["mp3"] , width:"33" , height: "40" },
        ],
        backendSuffix:[
          "bmp", "gif", "jpg", "jpeg", "png", "raw",
          "doc", "docx", "xls", "xlsx", "ppt", "pptx", "html", "htm", "txt", 
          "rar", "zip", "gz", "bz2", 
          "mp4", "avi", "rmvb", "mov",
          "pdf"
        ],
        backendSuffixUpperCase:[],
        routeQuery: {
          maxCount: 6
        },
      }
    },
    created(){
      this.fileSuffixList = this.fileSuffixList.map(fileItem=>({ ...fileItem , suffixList: this.handleToLocaleUpperCase(fileItem.suffixList) }));
      this.backendSuffixUpperCase = this.backendSuffix.map(item=>item.toLocaleUpperCase());
      this.routeQuery = this.deepClone({
        ...this.routeQuery,
        ...this.$route.query
      });
    },
    methods:{
      handleToLocaleUpperCase(list){
        let newList = [];
        list.map(item => {
          newList.push(item);
          newList.push(item.toLocaleUpperCase());
        });
        return newList;
      },
      handleCancel(){
        window.uni.navigateBack({ delta: 1 });
      },
      handleSubmit(){
        window.uni.postMessage({ data: "finish" });
        window.uni.navigateBack({ delta: 1 });
      },
      handleDelete(item,index){
        this.$dialog.confirm({
          message: `确定要删除"${item.fileName}"吗？`,
          allowHtml:false,
          confirmButtonColor:'#EC892E'
        }).then(()=>{
          this.fileList.splice(index,1);
          window.uni.postMessage({ data: this.fileList });
        })
      },
      handleSelectFile(){
        document.querySelector("#uFile").click();
      },
      handleInputUpload(e){
        if(!getToken()) {
          this.$toast({ message: '登录信息缺失，请返回重新登录', icon: 'fail' });
          return;
        }
        this.$loading.open();
        var files = document.getElementById('uFile').files;
        let [fileName, fileSize, fileType, lastModifiedDate] = [files[0].name, files[0].size, files[0].type, files[0].lastModifiedDate];
        let file = e.target.files[0]
        let fileSuffixIndex = file.name.lastIndexOf(".");
        let fileSuffix = file.name.slice(fileSuffixIndex+1);
        if(!this.backendSuffix.concat(this.backendSuffixUpperCase).includes(fileSuffix)) {
          this.$dialog.alert({
            message: `请上传[${this.backendSuffix}]格式文件`,
            allowHtml:false,
            confirmButtonColor:'#EC892E'
          });
          return this.$loading.close();
        }else if(file.size > 1024 * 1024 * 50) {
          this.$dialog.alert({
            message: `请上传小于50MB大小的文件`,
            allowHtml:false,
            confirmButtonColor:'#EC892E'
          });
          return this.$loading.close();
        }
        let param = new FormData()
        param.append('file', file)
        upload(param)
        .then(res => {
          if(res.code !== 200) return this.$toast({message: res.msg ,icon:"fail"});
          this.fileList.push({
            fileId: res.data.fileId,
            fileUrl: res.data.url,
            fileName,
            fileSize,
            fileType: fileName.slice(fileName.lastIndexOf(".")),
            lastModifiedDate: parseTime(lastModifiedDate)
          });
          window.uni.postMessage({ data: this.fileList });
          document.getElementById('uFile').value = '';
        }).catch(() => {
        }).finally(() => {
          this.$loading.close();
        })
      },
      filesizeFormat(size) {
        if (!size) return "";
        var num = 1024.00;
        if (size < num)
            return size + "B";
        if (size < Math.pow(num, 2))
            return (size / num).toFixed(2) + "KB";
        if (size < Math.pow(num, 3))
            return (size / Math.pow(num, 2)).toFixed(2) + "MB";
        if (size < Math.pow(num, 4))
            return (size / Math.pow(num, 3)).toFixed(2) + "G";
        return (size / Math.pow(num, 4)).toFixed(2) + "T";
      },
      handleFileIconOption(fileName){
        let suffixIndex = fileName.lastIndexOf(".");
        let suffix = fileName.slice(suffixIndex+1);
        let suffixActive = this.fileSuffixList.find(item=>item.suffixList.includes(suffix));
        return suffixActive ? suffixActive : { iconName: "unknown-icon" , suffixList:[] , width: "36" , height: "40"};
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
    .files-upload {
      padding: 32px 0;
      .upload-button {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #EC892E;
        margin-bottom: 16px;
        .add-o {
          margin-right: 8px;
          color: #EC892E;
          font-weight: bold;
        }
      }
      .file-list {
        background-color: #FFF;
        padding: 8px 12px;
        .file-item + .file-item {
          margin-top: 8px;
        }
        .file-item {
          border: 1px solid #EFEFEF;
          padding: 18px 16px 16px 16px;
          overflow: hidden;
          .file-name {
            font-size: 16px;
            line-height: 24px;
            color: #333;
            word-break: break-all;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .file-name-suffix {
            flex-shrink: 0;
            font-size: 16px;
            line-height: 24px;
            color: #333;
          }
          .file-delete {
            font-size: 12px;
            color: #DC3C33;
            line-height: 24px;
            flex-shrink: 0;
            margin-left: 16px;
            flex-shrink: 0;
          }
          .file-size {
            font-size: 12px;
            color: #A6B6C6;
            line-height: 20px;
          }
          .file-upload-time {
            font-size: 12px;
            line-height: 12px;
            color: #A6B6C6;
            margin-top: 16px;
          }
        }
      }
      .pages-footer {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        .button {
            width: 122px;
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFF;
            background: #EC892E;
            border: 1px solid #EC892E;
            border-radius: 4px;
            overflow: hidden;
            &:active {
                background-color: #FFBD2D;
                border-color: #FFBD2D;
            }
            &.--plain {
                background-color: #FFF;
                color: #EC892E;
                border-color: #EC892E;
                &:active {
                    background-color: #EC892E;
                    border-color: #EC892E;
                    color: #FFF;
                }
            }
        }
      }
    }
  </style>
